class ToTop{
	constructor(target,fixer,speed,stop = true) {
		this.target = target;
		this.fixer = fixer;
		this.speed = speed;
		this.stop = stop;
	}

	clear_fixed_position(){
		let scrollHeight = $(document).height();
		let scrollPosition = $(window).height() + $(window).scrollTop();
		let footHeight = $("#footer").innerHeight();

		if ( scrollHeight - scrollPosition  <= footHeight ) {
			$(this.target).css({
				"position":"absolute",
				"bottom": footHeight + 30
			});
		} else { //それ以外の場合は
			$(this.target).css({
				"position":"fixed",
				"bottom": 30
			});
		}
	}

	exec(){
		const [target,fixer,speed] = [this.target,this.fixer,this.speed];
		const _this = this;
		$(window).on('load scroll',function(){
			if($(this).scrollTop() > fixer){
				$(target).fadeIn(speed);
			}else{
				$(target).fadeOut(speed);
			}

			if(this.stop){
				_this.clear_fixed_position();
			}
		});
	}
}
module.exports = ToTop;



// WEBPACK FOOTER //
// ./dev/js/scripts/ToTop.js